
class Annotation {
  constructor(){
    this.readyCallback = null;
    this.lineWidth = null;
    this.textSize = null;
  }

  get options(){
    return {
      textSize: this.textSize,
      lineWidth: this.lineWidth,
      color: this.color,
      scale: this.scale,
      transform: this.transform
    };
  }

  draw(){}

  setReadyCallback(readyCallback) {
    this.readyCallback = readyCallback;
  }

  setLineWidth(width) {
    this.lineWidth = width;
    this.signalReady();
  }
  
  setTextSize(size) {
    this.textSize = size;
    this.signalReady();
  }

  signalReady() {
    if (this.readyCallback && this.readyCallback instanceof Function)
      this.readyCallback();
  }  
}

export default Annotation;